import { useTranslation } from "react-i18next";

import { AnimatePresence, motion } from "framer-motion";

import Dialog from "@mui/material/Dialog";
import Button from "@mui/material/Button";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import DialogContentText from "@mui/material/DialogContentText";
import { anim } from "../Animations/utils";

// import PreviewPDF from "../PreviewPDF";
// <PreviewPDF pdfLink={aggrement.file.absolutePath} />

const animateAgreement = {
  initial: { x: "100%" },
  animate: {
    x: 0,
    transition: {
      duration: 0.4,
      ease: [0.165, 0.84, 0.44, 1],
    },
  },
  exit: {
    x: "100%",
    transition: { duration: 0.4, ease: [0.165, 0.84, 0.44, 1] },
  },
};

interface AgreementDialogProps {
  aggrements: IEntranceAgreementFile[];

  onDismiss: () => void;
  onSubmit: (id: string) => void;
}

const AgreementDialog = (props: AgreementDialogProps) => {
  const { t } = useTranslation(["previewPDF"]);
  const { aggrements, onDismiss, onSubmit } = props;

  const aggrement = aggrements[0];

  return (
    <AnimatePresence mode="wait">
      {!!aggrement && (
        <Dialog
          fullScreen
          open={!!aggrement}
          transitionDuration={0}
          component={motion.div}
          {...anim(animateAgreement)}
        >
          <DialogContent dividers className="p-0">
            {!!aggrement.text && (
              <>
                <DialogContentText
                  className="mb-5"
                  style={{ fontSize: "5rem", color: "#000000" }}
                >
                  {aggrement.title}
                </DialogContentText>
                <DialogContentText
                  style={{ fontSize: "3rem", color: "#000000" }}
                >
                  {aggrement.text}
                </DialogContentText>
              </>
            )}
            {aggrement?.file?.absolutePath?.endsWith("pdf") && (
              <iframe
                title="aggrement"
                src={`${aggrement.file.absolutePath}#toolbar=0`}
                width="100%"
                height="98%"
              />
            )}
            {!aggrement?.file?.absolutePath?.endsWith("pdf") && (
              <div
                className="ea-image h-100"
                style={{
                  backgroundImage: `url("${aggrement.file.absolutePath}#toolbar=0")`,
                }}
              />
            )}
          </DialogContent>
          <DialogActions className="p-5">
            <Button
              variant="contained"
              className="px-5 me-5 w"
              onClick={onDismiss}
            >
              {t("previewPDF:button.cancel")}
            </Button>

            <Button
              variant="contained"
              className="px-5"
              onClick={() => onSubmit(aggrement.id)}
            >
              {aggrement.approvalRequired
                ? t("previewPDF:button.accept")
                : t("previewPDF:button.next")}
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </AnimatePresence>
  );
};

export default AgreementDialog;
